import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as Hamburger } from 'assets/svg/icon-hamburger.svg'

const IconHamburger = (props: IconProps): JSX.Element => {
  const title = 'icon-hamburger'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <Hamburger {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconHamburger
